import React, { useEffect, useState } from "react";
import { getSavedItems, removeSavedItem, clearSavedItems } from "./storage";

export default function UserProfile() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    setItems(getSavedItems());
  }, []);

  const handleRemove = (id) => {
    removeSavedItem(id);
    setItems(getSavedItems());
  };

  const handleClear = () => {
    if (!window.confirm("Clear all saved items?")) return;
    clearSavedItems();
    setItems([]);
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl md:text-3xl font-semibold">Profile</h1>
        <p className="text-white/70 mt-1">
          Saved items are only visible to you (stored locally on this device).
        </p>
      </div>

      <div className="rounded-2xl bg-white/5 border border-white/10 p-4">
        <div className="flex items-center justify-between gap-3">
          <h2 className="font-semibold text-lg">Saved items</h2>
          <button
            onClick={handleClear}
            className="px-3 py-2 rounded-xl bg-white/10 hover:bg-white/15 border border-white/10 text-sm"
          >
            Clear all
          </button>
        </div>

        {items.length === 0 ? (
          <div className="text-white/70 mt-3">
            You haven’t saved anything yet. Browse the Directory and tap “Save”.
          </div>
        ) : (
          <div className="grid gap-3 mt-3 md:grid-cols-2">
            {items.map((it) => (
              <div
                key={it.id}
                className="rounded-2xl bg-white/5 border border-white/10 p-4"
              >
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <div className="text-xs text-white/60">{it.type}</div>
                    <h3 className="font-semibold">{it.title}</h3>
                    {it.meta && (
                      <div className="text-sm text-white/70 mt-1">{it.meta}</div>
                    )}
                  </div>
                  <button
                    onClick={() => handleRemove(it.id)}
                    className="px-3 py-2 rounded-xl bg-white/10 hover:bg-white/15 border border-white/10 text-sm"
                  >
                    Remove
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
